import moment from 'moment'
import path from 'ramda/src/path'
import pick from 'ramda/src/pick'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import uploadFile from 'root/src/client/util/uploadFile'
import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import { rewardEndpointIds } from 'root/src/shared/rewards/constants'

export default formData => async (dispatch) => {
	const formFile = path(['csvKeys', 'file'], formData)
	const keyType = path(['keyType', 'value'], formData)
	const platform = path(['platform', 'value'], formData)
	const region = path(['region', 'value'], formData)
	const id = path(['id', 'value'], formData)
	if (!formFile) {
		throw { csvKeys: 'Keys file is required' }
	}
	const filename = await uploadFile(formFile, dispatch, 60 * 24 * 3) // 3 days ttl

	const { body, error } = await dispatch(apiRequest(rewardEndpointIds.SAVE_KEY_REWARDS, {
		filename, keyType, platform, region, id, ...pick(['game', 'cta', 'url', 'shortUrl', 'dlcName', 'restrictions'], formData),
	}))

	if (error) {
		throw { csvKeys: error.message }
	}
	mixpanel.track(mixpanelEvents.brandProducts, { productType: brandProductTypesEnum.dropKey })
	mixpanel.people.set_once({ addedBrandProduct: moment().format() })

	return body
}
